module.exports = __webpack_public_path__ + "static/media/biology.93d87d05.jpg";